import * as React from "react";
import { connect } from "react-redux";
import Header from "./Header";
import { MultipleChoiceForm } from "./MultipleChoiceForm";
import { Choice } from "../../models/choice";
import { FormStep, Step } from "../../store/application/applicationState";
import { ApplicationAction, setHasCoApplicant, gotoStep } from "../../store/application/applicationActions";
import ApplicationContent from "../applicationContent";
import ApplicationFooter from "../applicationFooter";
import { Row, Col, Button } from "reactstrap";
import { trackEvent } from "../../util/gtm";


type Props = ReturnType<typeof mapDispatchToProps>;

class CoApplicant extends React.Component<Props, {}> {

    private choices: Array<Choice<boolean>> = [
        new Choice<boolean>("Ja", true, () => this.props.setHasCoApplicant(true)),
        new Choice<boolean>("Nej", false, () => this.props.setHasCoApplicant(false))
    ]

    render() {
        var params = window.location.search.toString();
        var regex = /((&|\?)step=)[0-9]{1,2}/gi;
        if (params != "") {
            params = params.replace(regex, "$1" + "8");
        }
        var stepQuery = window.location.protocol + "//" + window.location.host + window.location.pathname + params;
        window.history.pushState({ path: stepQuery }, '', stepQuery)
        return (
            <div>
                <Header formStep={FormStep.Other} step={Step.Coappliant} />
                <ApplicationContent>
                    <MultipleChoiceForm
                        title="Tilføj medansøger"
                        paragraph="Ønsker du at tilføje en medansøger"
                        choices={this.choices}
                        />
                </ApplicationContent>
                <ApplicationFooter>
                    <Row className="mt-2">
                        <Col className="col-12 text-right">
                            <Button className="back" onClick={() => this.props.previous()}>
                                Tilbage
                            </Button>
                        </Col>
                    </Row>
                </ApplicationFooter>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch: (action: ApplicationAction) => void) => ({
    setHasCoApplicant: (hasCoApplicant: boolean) => {
        dispatch(setHasCoApplicant(hasCoApplicant));
        trackEvent(
            "Har medansøger",
            hasCoApplicant ? "Har medansøger" : "Har ikke medansøger",
            "medansøger",
            hasCoApplicant ? "Har medansøger" : "Har ikke medansøger"
        )
    },
    previous: () => dispatch(gotoStep(Step.Children))
});

export default connect(
    null,
    mapDispatchToProps
)(CoApplicant);